const rootUrl =  document.querySelector('html').dataset.rootUrl;
function getLocation(initLocation) {
  if (initLocation) {
    localStorage.setItem("location", initLocation);
    return initLocation;
  }

  const location = localStorage.getItem("location");
  if (location) {
    return location;
  }

  return "";
}

function getCountryState(inputLocation){
  const location = inputLocation || getLocation();
  let country = location.slice(0, 2);
  let state = location.slice(2);
  return {country, state};
}

function showDropdown() {
  const modal = document.getElementById("location-picker-modal");
  modal.style.display = "flex";
}

function hideDropdown() {
  const modal = document.getElementById("location-picker-modal");
  modal.style.display = "none";
}

async function waitForLocationSelection() {
  return new Promise((resolve) => {
    document.addEventListener("locationSelected", (event) => {
      const selectedLocation = event.detail;
      hideDropdown();
      resolve(selectedLocation);
    });
  });
}

async function main() {
  let mainLocation = getLocation();
  const headerLocationPicker = window.headerLocationPicker;

  if (!mainLocation) {
    showDropdown();
    mainLocation = await waitForLocationSelection();
    getLocation(mainLocation);
  }

  const country = mainLocation.slice(0, 2);
  const state = mainLocation.slice(2);

  if (country !== "CA" && country !== "US") {
    showDropdown();
    mainLocation = await waitForLocationSelection();
    getLocation(mainLocation);
  }

  let zone = getZone(mainLocation);
  updateLocations(zone); 
  if (headerLocationPicker) {
    headerLocationPicker.value = getState(mainLocation);
  } else {
    console.error("headerLocationPicker is not defined");
  }
}

function getZone(value) {
  const matchingState = window.statesData.find(
    (state) => state["iso-code"] === value
  );
  return matchingState.code;
}
function getState(value) {
  const matchingState = window.statesData.find(
    (state) => state["iso-code"] === value
  );
  return matchingState['state-province'];
}

function updateLocations(location) {
  const collectionLinks = document.querySelectorAll(
    'a[href*="/collections/"]'
  );

  collectionLinks.forEach((link) => {
    const url = new URL(link.href, window.location.origin);
    const basePath = url.pathname;
    const searchParams = url.search;
    const existingLocation = basePath.match(/(east|west|penn|calgy|midw|clgy)$/);
    const updatedPath = existingLocation
      ? basePath.replace(existingLocation[0], location)
      : `${basePath}/${location}`;
    link.href = `${updatedPath}${searchParams}`;
  });
}
document.addEventListener("DOMContentLoaded", (event) => {
  main();
});

var statesData = [
  {
    region: "Alex West",
    "state-province": "Washington",
    code: "west",
    "iso-code": "USWA",
    "handle": "washington"
  },
  {
    region: "Alex West",
    "state-province": "Oregon",
    code: "west",
    "iso-code": "USOR",
    "handle": "oregon"
  },
  {
    region: "Alex West",
    "state-province": "California",
    code: "west",
    "iso-code": "USCA",
    "handle": "california"
  },
  {
    region: "Alex West",
    "state-province": "Nevada",
    code: "west",
    "iso-code": "USNV",
    "handle": "nevada"
  },
  {
    region: "Alex West",
    "state-province": "Idaho",
    code: "west",
    "iso-code": "USID",
    "handle": "idaho"
  },
  {
    region: "Alex West",
    "state-province": "Montana",
    code: "west",
    "iso-code": "USMT",
    "handle": "montana"
  },
  {
    region: "Alex West",
    "state-province": "Wyoming",
    code: "west",
    "iso-code": "USWY",
    "handle": "wyoming"
  },
  {
    region: "Alex West",
    "state-province": "Utah",
    code: "west",
    "iso-code": "USUT",
    "handle": "utah"
  },
  {
    region: "Alex West",
    "state-province": "Colorado",
    code: "west",
    "iso-code": "USCO",
    "handle": "colorado"
  },
  {
    region: "Alex West",
    "state-province": "Alaska",
    code: "west",
    "iso-code": "USAK",
    "handle": "alaska"
  },
  {
    region: "Alex West",
    "state-province": "Arizona",
    code: "west",
    "iso-code": "USAZ",
    "handle": "arizona"
  },
  {
    region: "Alex West",
    "state-province": "New Mexico",
    code: "west",
    "iso-code": "USNM",
    "handle": "new-mexico"
  },
  {
    region: "Alex West",
    "state-province": "North Dakota",
    code: "west",
    "iso-code": "USND",
    "handle": "north-dakota"
  },
  {
    region: "Alex West",
    "state-province": "South Dakota",
    code: "west",
    "iso-code": "USSD",
    "handle": "south-dakota"
  },
  {
    region: "Alex West",
    "state-province": "Nebraska",
    code: "west",
    "iso-code": "USNE",
    "handle": "nebraska"
  },
  {
    region: "Alex West",
    "state-province": "Kansas",
    code: "west",
    "iso-code": "USKS",
    "handle": "kansas"
  },
  {
    region: "Alex Mid West",
    "state-province": "Minnesota",
    code: "midw",
    "iso-code": "USMN",
    "handle": "minnesota"
  },
  {
    region: "Alex Mid West",
    "state-province": "Iowa",
    code: "midw",
    "iso-code": "USIA",
    "handle": "iowa"
  },
  {
    region: "Alex Mid West",
    "state-province": "Missouri",
    code: "midw",
    "iso-code": "USMO",
    "handle": "missouri"
  },
  {
    region: "Alex Mid West",
    "state-province": "Wisconsin",
    code: "midw",
    "iso-code": "USWI",
    "handle": "wisconsin"
  },
  {
    region: "Alex Mid West",
    "state-province": "Illinois",
    code: "midw",
    "iso-code": "USIL",
    "handle": "illinois"
  },
  {
    region: "Alex Mid West",
    "state-province": "Indiana",
    code: "midw",
    "iso-code": "USIN",
    "handle": "indiana"
  },
  {
    region: "Alex Mid West",
    "state-province": "Michigan",
    code: "midw",
    "iso-code": "USMI",
    "handle": "michigan"
  },
  {
    region: "Alex Mid West",
    "state-province": "Ohio",
    code: "midw",
    "iso-code": "USOH",
    "handle": "ohio"
  },
  {
    region: "Alex West",
    "state-province": "Oklahoma",
    code: "west",
    "iso-code": "USOK",
    "handle": "oklahoma"
  },
  {
    region: "Alex North East",
    "state-province": "Arkansas",
    code: "penn",
    "iso-code": "USAR",
    "handle": "arkansas"
  },
  {
    region: "Alex East",
    "state-province": "Ontario",
    code: "east",
    "iso-code": "CAON",
    "handle": "ontario"
  },
  {
    region: "Alex East",
    "state-province": "Quebec",
    code: "east",
    "iso-code": "CAQC",
    "handle": "quebec",
    "redirect": "fr"
  },
  {
    region: "Alex North East",
    "state-province": "Maine",
    code: "penn",
    "iso-code": "USME",
    "handle": "maine"
  },
  {
    region: "Alex North East",
    "state-province": "New Hampshire",
    code: "penn",
    "iso-code": "USNH",
    "handle": "new-hampshire"
  },
  {
    region: "Alex North East",
    "state-province": "Vermont",
    code: "penn",
    "iso-code": "USVT",
    "handle": "vermont"
  },
  {
    region: "Alex North East",
    "state-province": "Massachusetts",
    code: "penn",
    "iso-code": "USMA",
    "handle": "massachusetts"
  },
  {
    region: "Alex North East",
    "state-province": "Connecticut",
    code: "penn",
    "iso-code": "USCT",
    "handle": "connecticut"
  },
  {
    region: "Alex North East",
    "state-province": "Rhode Island",
    code: "penn",
    "iso-code": "USRI",
    "handle": "rhode-island"
  },
  {
    region: "Alex North East",
    "state-province": "New York",
    code: "penn",
    "iso-code": "USNY",
    "handle": "new-york"
  },
  {
    region: "Alex North East",
    "state-province": "Pennsylvania",
    code: "penn",
    "iso-code": "USPA",
    "handle": "pennsylvania"
  },
  {
    region: "Alex North East",
    "state-province": "New Jersey",
    code: "penn",
    "iso-code": "USNJ",
    "handle": "new-jersey"
  },
  {
    region: "Alex North East",
    "state-province": "Delaware",
    code: "penn",
    "iso-code": "USDE",
    "handle": "delaware"
  },
  {
    region: "Alex North East",
    "state-province": "Maryland",
    code: "penn",
    "iso-code": "USMD",
    "handle": "maryland"
  },
  {
    region: "Alex North East",
    "state-province": "Virginia",
    code: "penn",
    "iso-code": "USVA",
    "handle": "virginia"
  },
  {
    region: "Alex North East",
    "state-province": "West Virginia",
    code: "penn",
    "iso-code": "USWV",
    "handle": "west-virginia"
  },
  {
    region: "Alex North East",
    "state-province": "North Carolina",
    code: "penn",
    "iso-code": "USNC",
    "handle": "north-carolina"
  },
  {
    region: "Alex North East",
    "state-province": "South Carolina",
    code: "penn",
    "iso-code": "USSC",
    "handle": "south-carolina"
  },
  {
    region: "Alex North East",
    "state-province": "Georgia",
    code: "penn",
    "iso-code": "USGA",
    "handle": "georgia"
  },
  {
    region: "Alex North East",
    "state-province": "Florida",
    code: "penn",
    "iso-code": "USFL",
    "handle": "florida"
  },
  {
    region: "Calgary",
    "state-province": "British Columbia",
    code: "clgy",
    "iso-code": "CABC",
    "handle": "british-columbia" 
  },
  {
    region: "Calgary",
    "state-province": "Alberta",
    code: "clgy",
    "iso-code": "CAAB",
    "handle": "alberta" 
  },
  {
    region: "Calgary",
    "state-province": "Saskatchewan",
    code: "clgy",
    "iso-code": "CASK",
    "handle": "saskatchewan" 
  },
  {
    region: "Calgary",
    "state-province": "Manitoba",
    code: "clgy",
    "iso-code": "CAMB",
    "handle": "manitoba" 
  },
  {
    region: "Calgary",
    "state-province": "Yukon",
    code: "clgy",
    "iso-code": "CAYT",
    "handle": "yukon" 
  },
  {
    region: "Calgary",
    "state-province": "Northwest Territories",
    code: "clgy",
    "iso-code": "CANT",
    "handle": "northwest-territories" 
  },
  {
    region: "Calgary",
    "state-province": "Nunavut",
    code: "clgy",
    "iso-code": "CANU",
    "handle": "nunavut" 
  },
  {
    region: "Alex West",
    "state-province": "Texas",
    code: "west",
    "iso-code": "USTX",
    "handle": "texas" 
  },
  {
    region: "Alex North East",
    "state-province": "District of Columbia",
    code: "penn",
    "iso-code": "USDC",
    "handle": "district-of-columbia" 
  },
  {
    region: "Alex North East",
    "state-province": "Tennessee",
    code: "penn",
    "iso-code": "USTN",
    "handle": "tennessee" 
  },
  {
    region: "Alex North East",
    "state-province": "Kentucky",
    code: "penn",
    "iso-code": "USKY",
    "handle": "kentucky" 
  },
  {
    region: "Alex East",
    "state-province": "Prince Edward Island",
    code: "east",
    "iso-code": "CAPE",
    "handle": "prince-edward-island" 
  },
  {
    region: "Alex East",
    "state-province": "Nova Scotia",
    code: "east",
    "iso-code": "CANS",
    "handle": "nova-scotia" 
  },
  {
    region: "Alex East",
    "state-province": "Newfoundland and Labrador",
    code: "east",
    "iso-code": "CANL",
    "handle": "newfoundland-and-labrador" 
  },
  {
    region: "Alex East",
    "state-province": "New Brunswick",
    code: "east",
    "iso-code": "CANB",
    "handle": "new-brunswick" 
  },
  {
    region: "Alex North East",
    "state-province": "Louisiana",
    code: "penn",
    "iso-code": "USLA",
    "handle": "louisiana" 
  },
  {
    region: "Alex North East",
    "state-province": "Mississippi",
    code: "penn",
    "iso-code": "USMS",
    "handle": "mississippi" 
  },
  {
    region: "Alex North East",
    "state-province": "Alabama",
    code: "penn",
    "iso-code": "USAL",
    "handle": "alabama" 
  }
];
